
























































































































































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import CtrlAddBtn from '@/components/common/control/CtrlAddBtn.vue';
import CtrlAddFromListBtn from '@/components/common/control/CtrlAddFromListBtn.vue';
import CtrlAttachment from '@/components/common/control/CtrlAttachment.vue';
import CtrlDatePicker from '@/components/common/control/CtrlDatePicker.vue';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import CtrlNormalBtn from '@/components/common/control/CtrlNormalBtn.vue';
import CtrlNormalTxt from '@/components/common/control/CtrlNormalTxt.vue';
import CtrlNumTxt from '@/components/common/control/CtrlNumTxt.vue';
import CtrlSelect from '@/components/common/control/CtrlSelect.vue';
import ListMitsumoriHimmoku from '@/components/common/search/ListMitsumoriHimmoku.vue';
import G_020_JuchuEntry_ChildDetailInput from '@/components/G_kaigai/G_020_JuchuEntry_ChildDetailInput.vue';
import G_020_JuchuEntry_ChildHeaderInput_Table from '@/components/G_kaigai/G_020_JuchuEntry_ChildHeaderInput_Table.vue';
import {
  Flg,
  OutStatus,
  SeikyusakiKb,
  HaisoKb,
  ShoriKb,
  UmuFlg,
  KainaiKaigaiKb,
  MeishoBunruiCd,
  TaishoFlg,
  MukoFlg,
  JUCHU_LIMIT_TIME
} from '@/constants/constants';
import { BUTTON } from '@/constants/label';
import {
  add,
  calcAmount,
  convertStr2Num,
  dateStrToNum,
  isShorikbADD,
  isShorikbREFER,
  isShorikbUPD,
} from '@/utils/utils';
import moment from 'moment';
import Vue from 'vue';
import { mapGetters } from 'vuex';

/* eslint-disable @typescript-eslint/no-explicit-any */
export default Vue.extend<any, any, any, any>({
  name: 'G_020_JuchuEntry_ChildHeaderInput',
  components: {
    CtrlNormalBtn,
    CtrlMessageDialog,
    G_020_JuchuEntry_ChildHeaderInput_Table,
    G_020_JuchuEntry_ChildDetailInput,
    CtrlNumTxt,
    CtrlSelect,
    CtrlNormalTxt,
    CtrlAttachment,
    CtrlDatePicker,
    CtrlAddBtn,
    CtrlAddFromListBtn,
    ListMitsumoriHimmoku,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    shoriKb: {
      type: Number,
      default: ShoriKb.ADD,
    },
    childItem: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    BUTTON,
    Flg,
    SeikyusakiKb,
    KainaiKaigaiKb,
    UmuFlg,
    HaisoKb,
    MukoFlg,

    childHeaderInput: {
      tokuisakiHatchuNo: 0,
      hatchuYmd: 0,
      tokuisakiCd: 0,
      tokuisakiMei: '',
      nohinsakiCd: 0,
      jishaDenpyoNo: '',
      haisoKb: HaisoKb.HAISO,
      nohinKiboYmd: 0,
      hikitoriBinmei: '',
      hatchuBiko: '',
      nyukoBiko: '',
      tempEntryYmd: 0,
      tempSeq: 0,
      tempData: '',
      tempDate: '',
      tempFileName: '',
      tempUmuFlg: 0,
      juchuEntryJigyoshoCd: 0,
      juchuEntryYmd: 0,
      koshinCountHeader: 0,
      koshinCountDetailSum: 0,
      tankaHyojiKb: UmuFlg.NASHI,
      hasuHyojiKb: UmuFlg.NASHI,
      jotai: '',
      detailData: [],
    },
    tokuisakiItems: [],
    haisoItems: [],
    nohinsakiItems: [],
    childDetailShoriKb: ShoriKb.ADD,
    childDetailInputItem: {},
    childDetailInputShow: false,
    messageShow: false,
    messageId: '',
    messageTextParam: [],
    cMessageShow1: false,
    cMessageId1: '',
    cMessageTextParam1: [],
    messageConfirmSubmit: false,
    isReload: false,
    formKey: 0,

    mitsumoriHimmokuShow: false,
    mitsumoruHimmokuList: [],
    mounted: false,
  }),
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
      childHeaderTitle: 'common/childHeaderTitle',
    }),
    isAdd() {
      return isShorikbADD(this.shoriKb);
    },
    isUpd() {
      return isShorikbUPD(this.shoriKb);
    },
    isRef() {
      return isShorikbREFER(this.shoriKb);
    },
    juchuJuryoTotal() {
      return this.childHeaderInput.detailData.reduce(
        (total: number, item: any) => (total = add(item['juchuJuryo'], total)),
        0
      );
    },
    juchuZeinukiKingakuTotal() {
      return this.childHeaderInput.detailData.reduce(
        (total: number, item: any) =>
          (total = add(item['juchuZeinukiKingaku'], total)),
        0
      );
    },
  },
  watch: {
    'childHeaderInput.tokuisakiCd': {
      async handler(newValue: any) {
        // Tooltipの得意先名をクリア（ちらつき防止）
        this.childHeaderInput.tokuisakiMei = '';

        if (newValue) {
          await this.getNohinsakiItems();
          await this.getHyojiKb();
          if (!this.mounted) return;
          await this.handleReCalcChildItem();
          
          // Tooltipの得意先名をセット
          this.setTokuisakiMei();
        } else {
          this.childHeaderInput.nohinsakiCd = 0;
          this.childHeaderInput.tokuisakiMei = '';
        }
      },
    },
    'childHeaderInput.haisoKb': {
      handler() {
        if (!this.mounted) return;
        this.handleReCalcChildItem();
      },
    },
    'childHeaderInput.nohinsakiCd': {
      handler() {
        if (!this.mounted) return;
        this.handleReCalcChildItem();
      },
    },
    'childHeaderInput.nohinKiboYmd': {
      handler() {
        if (!this.mounted) return;
        this.handleReCalcChildItem();
      },
    },
  },
  methods: {
    hide(reload = true) {
      this.$emit('update:show', false);
      this.$emit('hide', reload);
    },
    handleChildDetailInputCancel() {
      this.childDetailInputShow = false;
      this.mitsumoruHimmokuList = [];
    },
    async getHyojiKb() {
      await this.$store
        .dispatch('common/getTokuisakiMst', {
          jigyoshoCd: this.childHeaderInput.juchuEntryJigyoshoCd,
          seikyusakiKb: SeikyusakiKb.TOKUISAKI,
          tokuisakiCd: this.childHeaderInput.tokuisakiCd,
          mukoUmuFlg: UmuFlg.NASHI,
          riyoshaTokuisakiTaishoFlg: TaishoFlg.TAISHO,
        })
        .then((res: any) => {
          if (res.data.responseData && res.data.responseData.length > 0) {
            this.childHeaderInput.tankaHyojiKb =
              res.data.responseData[0].gaibuSaitoTankaHyojiKb;
            this.childHeaderInput.hasuHyojiKb =
              res.data.responseData[0].gaibuSaitoHasuHyojiKb;
          } else {
            this.childHeaderInput.tankaHyojiKb = UmuFlg.NASHI;
            this.childHeaderInput.hasuHyojiKb = UmuFlg.NASHI;
          }
          this.formKey += 1;
        });
    },
    async getTokuisakiItems() {
      await this.$store
        .dispatch('common/getTokuisakiMst', {
          jigyoshoCd: this.childHeaderInput.juchuEntryJigyoshoCd,
          seikyusakiKb: SeikyusakiKb.TOKUISAKI,
          mukoUmuFlg: this.isRef ? UmuFlg.ARI : UmuFlg.NASHI,
          riyoshaTokuisakiTaishoFlg: TaishoFlg.TAISHO,
        })
        .then((res: any) => {
          let tokuisakiItems = [] as any;
          if (res.data.responseData && res.data.responseData.length > 0)
            tokuisakiItems = res.data.responseData;
          this.tokuisakiItems = tokuisakiItems;

          if (
            this.isAdd &&
            this.tokuisakiItems &&
            this.tokuisakiItems.length === 1
          ) {
            this.childHeaderInput.tokuisakiCd =
              this.tokuisakiItems[0].tokuisakiCd;
          }
          this.formKey += 1;
        });
    },
    async getNohinsakiItems() {
      await this.$store
        .dispatch('common/getNohinsakiMst', {
          jigyoshoCd: this.childHeaderInput.juchuEntryJigyoshoCd,
          tokuisakiCd: this.childHeaderInput.tokuisakiCd,
          mukoUmuFlg: this.isRef ? UmuFlg.ARI : UmuFlg.NASHI,
        })
        .then((res: any) => {
          let nohinsakiItems = [] as any;
          if (res.data.responseData && res.data.responseData.length > 0)
            nohinsakiItems = res.data.responseData;
          this.nohinsakiItems = nohinsakiItems;

          if (this.nohinsakiItems && this.nohinsakiItems.length === 1) {
            this.childHeaderInput.nohinsakiCd =
              this.nohinsakiItems[0].nohinsakiCd;
          }
          if (
            this.nohinsakiItems &&
            this.nohinsakiItems.length !== 1 &&
            this.mounted
          ) {
            this.childHeaderInput.nohinsakiCd = 0;
          }
          this.formKey += 1;
        });
    },
    async getHaisoItems() {
      await this.$store
        .dispatch('common/getMeishoMst', {
          meishoBunruiCd: MeishoBunruiCd.HAISO_KB,
          mukoUmuFlg: this.isRef ? UmuFlg.ARI : UmuFlg.NASHI,
        })
        .then((res: any) => {
          let haisoItems = [] as any;
          if (res.data.responseData && res.data.responseData.length > 0)
            haisoItems = res.data.responseData.map((item: any) => ({
              ...item,
              meishoCd: +item.meishoCd,
            }));
          this.haisoItems = haisoItems;
        });
    },
    setTokuisakiMei() {
      // Tooltipの得意先名をセット
      if (this.tokuisakiItems && this.childHeaderInput &&
          this.childHeaderInput.tokuisakiCd) {
        let selItem = this.tokuisakiItems.filter(
          (item: any) => item.tokuisakiCd === this.childHeaderInput.tokuisakiCd
        );
        if (selItem.length === 1) {
          this.childHeaderInput.tokuisakiMei = selItem[0].tokuisakiMei1 + (selItem[0].tokuisakiMei2 ? ' ' + selItem[0].tokuisakiMei2 : '');
        } else {
          this.childHeaderInput.tokuisakiMei = '';
        }
      }
    },
    async handleReCalcChildItem() {
      if (!this.mounted) return;
      const { tokuisakiCd, nohinsakiCd, haisoKb, nohinKiboYmd, detailData } =
        this.childHeaderInput;
      if (
        !tokuisakiCd ||
        !nohinsakiCd ||
        !haisoKb ||
        !nohinKiboYmd ||
        !detailData.length
      ) {
        return;
      }
      const newDetailData = await Promise.all(
        detailData.map(async (item: any) => {
          if (this.childHeaderInput.hasuHyojiKb === UmuFlg.NASHI){
            item.hasuSuryo  = 0;
          }
          const { himmokuCd, juchuSuryo, hasuSuryo, irisu } = item;
          const resMT = await this.handleMitsumoriTanka(himmokuCd, juchuSuryo);
          const juchuZeinukiKingaku = calcAmount(
            resMT.juchuTanka,
            juchuSuryo,
            hasuSuryo,
            irisu,
            resMT.bubikiTanka
          );

          return {
            ...item,
            ...resMT,
            juchuZeinukiKingaku,
          };
        })
      );

      this.childHeaderInput = {
        ...this.childHeaderInput,
        detailData: newDetailData,
      };
    },
    async handleMitsumoriTanka(himmokuCd: number, suryo: number) {
      const {
        juchuEntryJigyoshoCd: jigyoshoCd,
        tokuisakiCd,
        nohinsakiCd,
        haisoKb,
        nohinKiboYmd,
      } = this.childHeaderInput;

      const res = await this.$store.dispatch('common/getMitsumoriTanka', {
        jigyoshoCd,
        tokuisakiCd,
        nohinsakiCd,
        himmokuCd,
        haisoKb,
        suryo,
        targetYmd: dateStrToNum(nohinKiboYmd),
      });
      if (res && res.data && res.data.responseData) {
        const { mitsumoriTanka: juchuTanka, bubikiTanka } =
          res.data.responseData;
        return {
          juchuTanka,
          bubikiTanka,
          mitsumoriTankaUmuFlg: UmuFlg.ARI,
        };
      }
      return {
        juchuTanka: 0,
        bubikiTanka: 0,
        mitsumoriTankaUmuFlg: UmuFlg.NASHI,
      };
    },
    handleOkMessage() {
      this.messageShow = false;
      this.messageId = '';
      this.messageTextParam = [];
      if (this.isReload) {
        this.hide();
      }
      if (this.messageConfirmSubmit) {
        this.messageConfirmSubmit = false;
        this.handleSubmit();
      }
    },
    async handleDelete() {
      this.$store.dispatch('common/setIsLoading', true);
      const {
        juchuEntryJigyoshoCd,
        juchuEntryYmd,
        tokuisakiHatchuNo,
        koshinCountHeader,
        koshinCountDetailSum,
      } = this.childItem;

      const params = {
        juchuEntryJigyoshoCd,
        juchuEntryYmd: dateStrToNum(juchuEntryYmd),
        tokuisakiHatchuNo,
        jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
        genzaiYmd: this.userInfo.onlineData.genzaiYmd,
        koshinCountHeader,
        koshinCountDetailSum,
      };
      const res = await this.$store.dispatch(
        'g020/deleteJuchuEntryItem',
        params
      );
      this.$store.dispatch('common/setIsLoading', false);
      const { error } = res.data;
      if (
        res &&
        res.status == 200 &&
        res.data &&
        res.data.error &&
        res.data.error.messageID &&
        res.data.error.outStatus &&
        res.data.error.outStatus != OutStatus.NORMAL
      ) {
        if (error.outStatus == OutStatus.CHECK_ERR) {
          this.messageShow = true;
          this.messageId = error.messageID;
          this.messageTextParam = error.messageArgs;
          return;
        } else if (error.outStatus == OutStatus.EXCLUSIVE_ERR) {
          this.messageShow = true;
          this.messageId = error.messageID;
          this.messageTextParam = error.messageArgs;
          this.isReload = true;
          return;
        }
      }
      this.hide();
    },
    handleFileAttachment(fileData: any) {
      this.childHeaderInput.tempData = fileData.tempData;
      this.childHeaderInput.tempDate = fileData.tempDate;
      this.childHeaderInput.tempUmuFlg = fileData.tempUmuFlg;
    },
    handleShowFileNotFound(messageId: string) {
      this.messageShow = true;
      this.messageId = messageId;
      this.messageTextParam = [];
      this.isReload = true;
    },
    async handleListMitsumoriHimmokuShow() {
      if (await this.checkValidate()) {
        this.childDetailInputShoriKb = ShoriKb.ADD;
        this.mitsumoriHimmokuShow = true;
      }
    },
    async handleAddFromList(himmokuItem: any) {
      const childHeaderInput = this.childHeaderInput;
      const {
        juchuEntryJigyoshoCd,
        tokuisakiCd,
        nohinsakiCd,
        haisoKb,
        nohinKiboYmd,
        tankaHyojiKb,
        hasuHyojiKb,
      } = childHeaderInput;

      const { himmokuCd, himmokuMei, tani, irisu } = himmokuItem;
      this.childDetailInputItem = {
        juchuEntryJigyoshoCd,
        tokuisakiCd,
        nohinsakiCd,
        haisoKb,
        nohinKiboYmd,
        tankaHyojiKb,
        hasuHyojiKb,
        mitsumoriTankaUmuFlg: UmuFlg.NASHI,
        himmokuCd,
        himmokuMei,
        tani,
        irisu,
        himmokuItem,
        isAddFromList: true,
      };
      this.childDetailShoriKb = ShoriKb.ADD;
      this.childDetailInputShow = true;
    },
    async handleAdd() {
      if (await this.checkValidate()) {
        const childHeaderInput = this.childHeaderInput;
        const {
          juchuEntryJigyoshoCd,
          tokuisakiCd,
          nohinsakiCd,
          haisoKb,
          nohinKiboYmd,
          tankaHyojiKb,
          hasuHyojiKb,
        } = childHeaderInput;

        this.childDetailInputItem = {
          juchuEntryJigyoshoCd,
          tokuisakiCd,
          nohinsakiCd,
          haisoKb,
          nohinKiboYmd,
          tankaHyojiKb,
          hasuHyojiKb,
          mitsumoriTankaUmuFlg: UmuFlg.NASHI,
        };
        this.childDetailShoriKb = ShoriKb.ADD;
        this.childDetailInputShow = true;
      }
    },
    handleInfo(item: any) {
      const childHeaderInput = this.childHeaderInput;
      const { tokuisakiCd, nohinsakiCd, haisoKb } = childHeaderInput;
      this.childDetailInputItem = {
        ...item,
        juchuEntryJigyoshoCd: this.childHeaderInput.juchuEntryJigyoshoCd,
        tankaHyojiKb: this.childHeaderInput.tankaHyojiKb,
        hasuHyojiKb: this.childHeaderInput.hasuHyojiKb,
        tokuisakiCd,
        nohinsakiCd,
        haisoKb,
      };
      this.childDetailShoriKb = ShoriKb.REFER;
      this.childDetailInputShow = true;
    },
    async handleEdit(item: any) {
      if (await this.checkValidate()) {
        const childHeaderInput = this.childHeaderInput;
        const {
          juchuEntryJigyoshoCd,
          tokuisakiCd,
          nohinsakiCd,
          haisoKb,
          nohinKiboYmd,
          tankaHyojiKb,
          hasuHyojiKb,
        } = childHeaderInput;

        this.childDetailInputItem = {
          ...item,
          juchuEntryJigyoshoCd,
          tokuisakiCd,
          nohinsakiCd,
          haisoKb,
          nohinKiboYmd,
          tankaHyojiKb,
          hasuHyojiKb,
          mitsumoriTankaUmuFlg:
            item.mitsumoriTankaUmuFlg !== undefined
              ? item.mitsumoriTankaUmuFlg
              : UmuFlg.ARI,
        };
        this.childDetailShoriKb = ShoriKb.UPD;
        this.childDetailInputShow = true;
      }
    },
    getMitsumoruHimmoku(items: any) {
      this.mitsumoruHimmokuList = items;
      if (this.mitsumoruHimmokuList.length > 0) {
        const firstItem = this.mitsumoruHimmokuList.shift();
        this.handleAddFromList(firstItem);
      }
    },
    handleDeleteChildItem(item: any) {
      this.childHeaderInput.detailData.splice(item.index, 1);
    },
    handleSaveChildItem(newItem: any) {
      if (this.childDetailShoriKb === ShoriKb.UPD) {
        this.childHeaderInput.detailData = this.childHeaderInput.detailData.map(
          (item: any, index: number) => {
            if (index === newItem.index) {
              return newItem;
            }
            return item;
          }
        );
      } else {
        this.childHeaderInput.detailData.push(newItem);
        if (this.mitsumoruHimmokuList.length > 0) {
          const self = this;
          this.$nextTick(() => {
            const firstItem = self.mitsumoruHimmokuList.shift();
            this.handleAddFromList(firstItem);
          });
        }
      }
    },
    async handleSubmit() {
      // ローディング・スタート
      this.$store.dispatch('common/setIsLoading', true);
      const childHeaderInput = this.childHeaderInput;
      const {
        hatchuYmd,
        tokuisakiCd,
        nohinsakiCd,
        jishaDenpyoNo,
        haisoKb,
        hikitoriBinmei,
        nohinKiboYmd,
        hatchuBiko,
        nyukoBiko,
        tempData,
        detailData,
      } = childHeaderInput;

      const detailDataConverted = detailData.map(
        (item: any, index: number) => ({
          tokuisakiHatchuGyoNo: index + 1,
          himmokuCd: item.himmokuCd,
          irisu: convertStr2Num(item.irisu),
          juchuSuryo: convertStr2Num(item.juchuSuryo),
          hasuSuryo: convertStr2Num(item.hasuSuryo),
          juchuJuryo: convertStr2Num(item.juchuJuryo),
          juchuTanka: convertStr2Num(item.juchuTanka),
          bubikiTanka: convertStr2Num(item.bubikiTanka),
          juchuZeinukiKingaku: convertStr2Num(item.juchuZeinukiKingaku),
          meisaiBiko: item.meisaiBiko,
        })
      );

      const requestData = {
        commonInfo: {
          jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
          genzaiYmd: this.userInfo.onlineData.genzaiYmd,
        },
        juchuData: {
          juchuYmd: dateStrToNum(hatchuYmd),
          tokuisakiCd,
          nohinsakiCd,
          tokuisakiDenpyoNo: jishaDenpyoNo,
          haisoKb,
          hikitoriBinmei,
          nohinKiboYmd: dateStrToNum(nohinKiboYmd),
          tokuisakiBiko: hatchuBiko,
          nyukoBiko,
          tempData,
          detailData: detailDataConverted,
          // only Upd
          ...(this.isUpd && {
            juchuEntryJigyoshoCd: childHeaderInput.juchuEntryJigyoshoCd,
            juchuEntryYmd: childHeaderInput.juchuEntryYmd,
            tempUmuFlg: childHeaderInput.tempUmuFlg,
            tokuisakiHatchuNo: childHeaderInput.tokuisakiHatchuNo,
            koshinCountHeader: childHeaderInput.koshinCountHeader,
            koshinCountDetailSum: childHeaderInput.koshinCountDetailSum,
          }),
        },
      } as any;

      const actionName = this.isUpd
        ? 'g020/putJuchuEntryItem'
        : 'g020/postJuchuEntry';
      const res = await this.$store.dispatch(actionName, requestData);
      this.$store.dispatch('common/setIsLoading', false);

      if (
        res &&
        res.status == 200 &&
        res.data &&
        res.data.error &&
        res.data.error.messageID &&
        res.data.error.outStatus &&
        res.data.error.outStatus != OutStatus.NORMAL
      ) {
        const { error } = res.data;
        if (error.outStatus == OutStatus.CHECK_ERR) {
          this.messageShow = true;
          this.messageId = error.messageID;
          this.messageTextParam = error.messageArgs;
          return;
        } else if (error.outStatus == OutStatus.EXCLUSIVE_ERR) {
          this.messageShow = true;
          this.messageId = error.messageID;
          this.messageTextParam = error.messageArgs;
          this.isReload = true;
          return;
        }
      }
      this.hide();
    },
    async handleSystemDateTime() {
      const res = await this.$store.dispatch('common/getSystemDateTime');
      if (res && res.data && res.data.responseData) {
        const { genzaiYmd, genzaiTime, yokuYmd } =
          res.data.responseData;
        return {
          genzaiYmd,
          genzaiTime,
          yokuYmd,
        };
      } else {
        return {
          genzaiYmd: Number(moment().format('YYYYMMDD')),
          genzaiTime: Number(moment().format('hhmm')),
          yokuYmd: Number(moment().add(1, "days").format('YYYYMMDD')),
        };
      }
    },
    async checkValidate(saveHeaderInput = false) {
      this.messageConfirmSubmit = false;
      await new Promise((resolve) => setTimeout(resolve, 300));
      this.$refs.form.validate();
      const childHeaderInput = this.childHeaderInput;
      const resSysdatetime = await this.handleSystemDateTime();

      if (!childHeaderInput.tokuisakiCd) {
        this.messageId = 'KI_W100';
        this.messageTextParam = ['得意先'];
        this.messageShow = true;
        return;
      }
      if (!childHeaderInput.haisoKb) {
        this.messageId = 'KI_W100';
        this.messageTextParam = ['配送区分'];
        this.messageShow = true;
        return;
      }
      if (!childHeaderInput.nohinsakiCd) {
        this.messageId = 'KI_W100';
        this.messageTextParam = ['納品先'];
        this.messageShow = true;
        return;
      }
      if (!dateStrToNum(childHeaderInput.nohinKiboYmd)) {
        this.messageId = 'KI_W100';
        this.messageTextParam = ['納品希望日'];
        this.messageShow = true;
        return;
      }
      if (saveHeaderInput && !childHeaderInput.detailData.length) {
        this.messageId = 'KI_W113';
        this.messageTextParam = ['明細'];
        this.messageShow = true;
        return;
      }
      if (
        dateStrToNum(childHeaderInput.nohinKiboYmd) <
        dateStrToNum(childHeaderInput.hatchuYmd)
      ) {
        this.messageId = 'KI_W109';
        this.messageTextParam = ['納品希望日', '発注日より過去'];
        this.messageShow = true;
        return;
      }
      if (
        dateStrToNum(childHeaderInput.nohinKiboYmd) <=
        Number(resSysdatetime.genzaiYmd)
      ) {
        this.messageId = 'KI_W108';
        this.messageTextParam = ['納品希望日'];
        this.messageShow = true;
        return;
      }
      if (
        dateStrToNum(childHeaderInput.nohinKiboYmd) ===
        Number(resSysdatetime.yokuYmd) &&
        Number(resSysdatetime.genzaiTime) > Number(JUCHU_LIMIT_TIME)
      ) {
        const msgTime = String(JUCHU_LIMIT_TIME).padStart(4, '0');
        this.messageId = 'KI_W123';
        this.messageTextParam = [
          msgTime.substring(0,2) + '時' + msgTime.substring(2,4) + '分を過ぎた',
          '指定した納品希望日は入力'
        ];
        this.messageShow = true;
        return;
      }
      if (saveHeaderInput) {
        if (childHeaderInput.detailData.length > 99) {
          this.messageId = 'KI_W104';
          this.messageTextParam = ['99行', '明細'];
          this.messageShow = true;
          return;
        }
        if (
          childHeaderInput.detailData.some(
            (item: any) => item.mitsumoriTankaUmuFlg === UmuFlg.NASHI
          )
        ) {
          this.messageId = 'KI_W123';
          this.messageTextParam = ['明細の見積単価が取得できない', '処理'];
          this.messageShow = true;
          return;
        }
      }
      if (!this.$refs.form.validate()) {
        this.messageId = 'KI_W121';
        this.messageTextParam = [];
        this.messageShow = true;
        return;
      }
      return true;
    },
    async getData() {

      if (this.childItem.rirekiNo == null)
      {
        const { juchuEntryJigyoshoCd, juchuEntryYmd, tokuisakiHatchuNo } =
          this.childItem;

        const params = {
          juchuEntryJigyoshoCd,
          juchuEntryYmd: dateStrToNum(juchuEntryYmd),
          tokuisakiHatchuNo,
        };
        const res = await this.$store.dispatch('g020/getJuchuEntryItem', params);
        if (
          res &&
          res.status == 200 &&
          res.data &&
          res.data.error &&
          res.data.error.outStatus &&
          res.data.error.outStatus != OutStatus.NORMAL
        ) {
          this.$store.dispatch('common/setIsLoading', false);
          this.messageId = res.data.error.messageID;
          this.messageTextParam = res.data.error.messageArgs;
          this.messageShow = true;
          this.isReload = true;
          return;
        }

        if (
          this.isUpd &&
          (res.data.responseData.koshinCountHeader !==
            this.childHeaderInput.koshinCountHeader ||
            res.data.responseData.koshinCountDetailSum !==
              this.childHeaderInput.koshinCountDetailSum)
        ) {
          this.$store.dispatch('common/setIsLoading', false);
          this.messageId = 'KI_W107';
          this.messageTextParam = [];
          this.messageShow = true;
          this.isReload = true;
          return;
        }
        
        this.childHeaderInput = {
          ...this.childHeaderInput,
          ...res.data.responseData,
        };

      }
      else
      {
        const { juchuEntryJigyoshoCd, juchuEntryYmd, juchuNo, rirekiNo } =
          this.childItem;

        const params = {
          juchuEntryJigyoshoCd,
          juchuEntryYmd: dateStrToNum(juchuEntryYmd),
          juchuNo,
          rirekiNo,
        };

        const res = await this.$store.dispatch('g030/getRirekiItem', params);
        if (
          res &&
          res.status == 200 &&
          res.data &&
          res.data.error &&
          res.data.error.outStatus &&
          res.data.error.outStatus != OutStatus.NORMAL
        ) {
          this.$store.dispatch('common/setIsLoading', false);
          this.messageId = res.data.error.messageID;
          this.messageTextParam = res.data.error.messageArgs;
          this.messageShow = true;
          this.isReload = true;
          return;
        }
        
        this.childHeaderInput = {
          ...this.childHeaderInput,
          ...res.data.responseData,
        };

      }

      this.$store.dispatch('common/setIsLoading', false);
    },
    async handleSave() {
      if (await this.checkValidate(true)) {
        const genzaiYmdAdd3Month = moment(
          this.userInfo.onlineData.genzaiYmd.toString()
        )
          .add(3, 'month')
          .format()
          .substr(0, 10);

        if (
          dateStrToNum(genzaiYmdAdd3Month) <
          dateStrToNum(this.childHeaderInput.nohinKiboYmd)
        ) {
          this.cMessageShow1 = true;
          this.cMessageId1 = 'KI_Q103';
          this.cMessageTextParam1 = [
            '納品希望日に指定した日付は３ヶ月超先です',
            '続行して',
          ];
          return;
        }
        this.cHandleSubmit1();
      }
    },
    cHandleSubmit1() {
      this.messageConfirmSubmit = true;
      this.messageId = 'KI_Q100';
      this.messageTextParam = [this.isUpd ? '変更' : '追加'];
      this.messageShow = true;
    },
  },
  async created() {
    this.childHeaderInput = {
      ...this.childHeaderInput,
      ...this.childItem,
    };
    this.$store.dispatch('common/getChildHeaderTitle', {
      shoriKb: this.shoriKb,
    });
    this.$store.dispatch('common/setIsLoading', true);

    await Promise.all([this.getTokuisakiItems(), this.getHaisoItems()]);

    if (this.isAdd) {
      this.$store.dispatch('common/setIsLoading', false);
      this.childHeaderInput.hatchuYmd = this.userInfo.onlineData.genzaiYmd;
    } else {
      await this.getData();
    }

    // Tooltipの得意先名をセット
    this.setTokuisakiMei();
  },
  mounted() {
    setTimeout(() => {
      this.mounted = true;
    }, 3100);
  },
});
